import { gql } from '@apollo/client';

const ITEM_FRAGMENT = `
  _id
  label
  title
  subtitle
  description
  customImageUrl
  position
  isActive
  album {
    _id
    title
    imageUrl
    isSingle
    primaryArtist { _id displayName }
  }
`;

export const CREATE_NEW_SECTION_ITEM = gql`
  mutation CreateNewSectionItem(
    $label: String!
    $title: String!
    $subtitle: String
    $description: String
    $customImageUrl: String
    $albumId: ID
    $position: Int
  ) {
    item: createNewSectionItem(
      label: $label
      title: $title
      subtitle: $subtitle
      description: $description
      customImageUrl: $customImageUrl
      albumId: $albumId
      position: $position
    ) {
      ${ITEM_FRAGMENT}
    }
  }
`;

export const UPDATE_NEW_SECTION_ITEM = gql`
  mutation UpdateNewSectionItem(
    $_id: ID!
    $label: String
    $title: String
    $subtitle: String
    $description: String
    $customImageUrl: String
    $albumId: ID
    $isActive: Boolean
    $position: Int
  ) {
    item: updateNewSectionItem(
      _id: $_id
      label: $label
      title: $title
      subtitle: $subtitle
      description: $description
      customImageUrl: $customImageUrl
      albumId: $albumId
      isActive: $isActive
      position: $position
    ) {
      ${ITEM_FRAGMENT}
    }
  }
`;

export const DELETE_NEW_SECTION_ITEM = gql`
  mutation DeleteNewSectionItem($_id: ID!) {
    success: deleteNewSectionItem(_id: $_id)
  }
`;

export const REORDER_NEW_SECTION_ITEMS = gql`
  mutation ReorderNewSectionItems($orderedIds: [ID!]!) {
    reorderNewSectionItems(orderedIds: $orderedIds)
  }
`;

export const CREATE_NEW_SECTION_SONG = gql`
  mutation CreateNewSectionSong($songId: ID!, $position: Int) {
    entry: createNewSectionSong(songId: $songId, position: $position) {
      _id
      position
      song {
        _id
        name
        image
        primaryArtist { _id displayName }
      }
    }
  }
`;

export const DELETE_NEW_SECTION_SONG = gql`
  mutation DeleteNewSectionSong($_id: ID!) {
    success: deleteNewSectionSong(_id: $_id)
  }
`;

export const REORDER_NEW_SECTION_SONGS = gql`
  mutation ReorderNewSectionSongs($orderedIds: [ID!]!) {
    reorderNewSectionSongs(orderedIds: $orderedIds)
  }
`;

export const GET_HERO_IMAGE_UPLOAD_URL = gql`
  mutation GetHeroImageUploadUrl($filename: String!, $contentType: String!) {
    upload: getHeroImageUploadUrl(filename: $filename, contentType: $contentType) {
      uploadUrl
      publicUrl
    }
  }
`;

// Search helper — reuses the existing adminSearch resolver
export const ADMIN_SEARCH = gql`
  query HomeHeroesAdminSearch($term: String) {
    searchResponse: adminSearch(searchTerm: $term) {
      responseType
      id
      name
      image
      albumId
      plays
    }
  }
`;
